export const experiencestMeta = [
    [
        "Light Technician in Opera Varna",
        "Oct 2026 – Current",
        "Opera Varna is a Bulgarian opera house that has been operating for over 100 years. My role is to orientate and setup light systems for the opera house's performances.",
        [
            "Orientate lights and setup light systems for the opera house's performances",
            "Assist the light director in setting up the light systems for the opera house's performances"

        ]
    ],
    [
        "Call center agent in ResultCX for sky UK project",
        "Dec 2024 – Nov 2025.",
        "Sky UK is one of the biggest telecommunications, TV, and Broadband providers in the United Kingdom. My role is to provide support to residential clients.",
        [
            "Provide support for their Sky Q television boxes and Broadband products by either fixing problems over the phone, sending replacement equipment, or sending an engineer when necessary.",
            "Open, mediate, and close complaints CX’s have with their services"

        ]
    ],
    [
        "Freelancer in the VRChat social platform",
        "Jan 2023 – Dec 2024",
        "VRChat is a VR social platform with a great ecosystem allowing users to create their own worlds. The worlds could have several purposes from educational, to socializing, to relaxation.",
        [
            "Create, write, and develop scripts for other world builders' needs.",
            "Created several shaders for other world builders for their needs.",
            "Created a Discord to VRChat synchronization, allowing world moderators to easily have access to their tools and special areas."

        ]
    ],
    [
        "Freelancer in AltspaceVR social platform",
        "Jun 2021 – Jul 2022",
        "AltspaceVR is a VR social platform that allows creators such as myself to create worlds, movable objects, and scripts called MREs that allow us to create our systems.",
        [
            "Create, write, and develop successful MREs (Mixed Reality Extension) used in over 800 virtual worlds and events in AltspaceVR.",
            "Got commissioned to create, write, and develop an MRE which is used in over 6500 worlds and events in AltspaceVR",
            "Assisted company subject matter experts in creating virtual systems by consulting on MRE scripting methods"

        ]
    ]
]